import classNames from "classnames";
import {FiSearch} from "react-icons/fi";

import {Icon} from "@/components/icon/Icon.tsx";
import {Input} from "@/components/input/Input.tsx";
import {InputProps, InputSizes} from "@/components/input/Input.types.ts";
import {InputGroup} from "@/components/inputGroup/InputGroup.tsx";

import styles from "./SearchInput.module.scss";

type SearchInputProps = {
  className?: string;
  onChange: (v: string) => void;
  size?: InputSizes;
  variant?: "tableControlBar";
} & Omit<InputProps, "onChange">;

export const SearchInput = ({
  className,
  onChange,
  variant,
  placeholder = "Search...",
  style,
  ...props
}: SearchInputProps) => (
  <InputGroup
    endElement={<Icon icon={FiSearch} className="pulse-color-gray-500" />}
    className={classNames(className, variant ? styles[variant] : "")}
    style={style}
  >
    <Input
      type="search"
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      aria-label="Search..."
      {...props}
    />
  </InputGroup>
);
